/**
 * パスワード表示切替（data 属性駆動。ログイン画面 SCR-01 / 試作サイト LoginForm 準拠）
 *
 * マークアップ規約:
 *   <div class="lms-login__pw-wrap" data-lms-password-toggle>
 *     <input type="password" ...>
 *     <button type="button" data-lms-password-toggle-btn aria-label="パスワードを表示する" hidden>
 *       <span data-lms-password-icon="off"><!-- eyeOff --></span>
 *       <span data-lms-password-icon="on" hidden><!-- eye --></span>
 *     </button>
 *   </div>
 *
 * 挙動:
 *   - 入力が空のあいだはトグルボタンを表示しない（試作サイトと同じ）。
 *   - クリックで input の type を password / text に切り替え、アイコンと aria-label を差し替える。
 *   - 非表示状態では「目を閉じた」アイコン（off）を出す（＝押すと表示になる）。
 */
const SHOW_LABEL = "パスワードを表示する";
const HIDE_LABEL = "パスワードを非表示にする";

export function initPasswordToggle(scope: ParentNode = document): void {
  scope.querySelectorAll<HTMLElement>("[data-lms-password-toggle]").forEach((wrap) => {
    if (wrap.dataset["lmsPasswordToggleReady"] === "1") return;
    wrap.dataset["lmsPasswordToggleReady"] = "1";

    const input = wrap.querySelector<HTMLInputElement>("input");
    const button = wrap.querySelector<HTMLButtonElement>("[data-lms-password-toggle-btn]");
    if (!input || !button) return;

    const iconOn = button.querySelector<HTMLElement>('[data-lms-password-icon="on"]');
    const iconOff = button.querySelector<HTMLElement>('[data-lms-password-icon="off"]');

    // 入力の有無でトグルボタンの表示を切り替える
    const syncButtonVisibility = (): void => {
      button.hidden = input.value.length === 0;
    };

    // 表示状態を反映する（visible=true でパスワードが見えている）
    const setVisible = (visible: boolean): void => {
      input.type = visible ? "text" : "password";
      button.setAttribute("aria-label", visible ? HIDE_LABEL : SHOW_LABEL);
      if (iconOn) iconOn.hidden = !visible;
      if (iconOff) iconOff.hidden = visible;
    };

    setVisible(false);
    syncButtonVisibility();

    input.addEventListener("input", syncButtonVisibility);
    button.addEventListener("click", () => {
      setVisible(input.type === "password");
    });
  });
}
